/* eslint-disable no-tabs */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { setShareDashboardModal } from '../../ducks/sportCoachDashboardActions';
import ShareDashboardModal from './ShareDashboardModal';

const ShareDashboardModalOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-color: rgba(216, 216, 216, 0.8);
  z-index: 1002;
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
`;

const ShareDashboardModalContainer = () => {
  const dispatch = useDispatch();
  const isShareDashModalShowing = useSelector(
    (state) => state.sportCoachDashboard.ui.isShareDashModalShowing,
  );

  return (
    <>
      <ShareDashboardModal />
      <ShareDashboardModalOverlay
        isActive={isShareDashModalShowing}
        onClick={
          () => dispatch(setShareDashboardModal(false))
          }
      />
    </>
  );
};

ShareDashboardModalContainer.propTypes = { };

export default ShareDashboardModalContainer;
